import useSWR from "swr";
import axios from "axios";
import { useContext } from "react";
import { AuthContext } from "../../../context/AuthContext";
import { AdminEndpointEnum } from "../../../enums/endpoints";
import { ADMIN_API_URL } from "../../../utils/env";

export interface IAirtableRecord {
  [address: string]: string;
}

interface IAirtableTagsResponse {
  records: IAirtableRecord;
}

export const useAirtableTags = () => {
  const { tokenId, queryConfig } = useContext(AuthContext);
  const url = ADMIN_API_URL(AdminEndpointEnum.AIRTABLE_TAGS);

  return useSWR<IAirtableTagsResponse>(
    tokenId ? [url, tokenId] : null,
    async () => {
      const { data } = await axios.get<IAirtableTagsResponse>(url, queryConfig());
      if (
        !data?.records ||
        typeof data.records !== "object" ||
        Array.isArray(data.records) ||
        !Object.values(data.records).every((value) => typeof value === "string")
      ) {
        throw new Error("Invalid account tags response");
      }
      return data;
    },
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: true,
      dedupingInterval: 60000,
      revalidateOnMount: true,
      refreshWhenOffline: false,
      refreshWhenHidden: false,
      shouldRetryOnError: false,
    }
  );
};
